export const Endpoint = () => `/api/v3/admin/archives_force_update`;

export interface Payload {
    file_name: string;
}

export type Response = void;
